(function () {
  'use strict';

  const EMAIL = 'office@idancecontemporary.gallery';

  const modalHTML = `
  <div id="ce-modal-overlay" role="dialog" aria-modal="true">
    <div id="ce-modal-panel">
      <button id="ce-modal-close" aria-label="Close">&#x2715;</button>

      <div id="ce-modal-general">
        <p class="ce-modal-eyebrow">Get in touch</p>
        <h2 class="ce-modal-headline">What would you like to discuss?</h2>
        <div class="ce-topic-pills">
          <button class="ce-pill" data-topic="A specific artwork">A specific artwork</button>
          <button class="ce-pill" data-topic="Pricing &amp; editions">Pricing &amp; editions</button>
          <button class="ce-pill" data-topic="Shipping &amp; framing">Shipping &amp; framing</button>
          <button class="ce-pill" data-topic="Trade &amp; Interiors">Trade &amp; Interiors</button>
          <button class="ce-pill" data-topic="Something else">Something else</button>
        </div>
        <div id="ce-search-wrap">
          <input id="ce-search-input" type="text" placeholder="Search by artist or title..." autocomplete="off" />
          <div id="ce-search-shimmer"></div>
          <div id="ce-search-results"></div>
          <div id="ce-selected-product"></div>
        </div>
        <div class="ce-field-wrap">
          <input id="ce-name" type="text" placeholder=" " />
          <label for="ce-name">Your name</label>
        </div>
        <div class="ce-field-wrap">
          <input id="ce-email-field" type="email" placeholder=" " />
          <label for="ce-email-field">Your email</label>
        </div>
        <div class="ce-field-wrap">
          <textarea id="ce-message" rows="3" placeholder=" "></textarea>
          <label for="ce-message">Tell us more...</label>
        </div>
        <button id="ce-submit" class="ce-modal-btn">Send Enquiry →</button>
        <p class="ce-modal-note">We read every message personally.</p>
      </div>

      <div id="ce-modal-artist" style="display:none">
        <div class="ce-artist-header">
          <p class="ce-modal-eyebrow">Artist Submissions</p>
          <span id="ce-step-indicator">Step 1 of 3</span>
        </div>
        <div class="ce-progress-dots">
          <span class="ce-dot ce-dot--active"></span>
          <span class="ce-dot"></span>
          <span class="ce-dot"></span>
        </div>
        <div class="ce-step" id="ce-step-1">
          <h2 class="ce-modal-headline">About your practice.</h2>
          <div class="ce-field-wrap"><input id="ce-artist-name" type="text" placeholder=" " /><label for="ce-artist-name">Your name</label></div>
          <div class="ce-field-wrap"><textarea id="ce-artist-desc" rows="3" placeholder=" "></textarea><label for="ce-artist-desc">Describe your work</label></div>
          <div class="ce-medium-pills">
            <button class="ce-mpill" data-medium="Dance Photography">Dance Photography</button>
            <button class="ce-mpill" data-medium="Fine Art">Fine Art</button>
            <button class="ce-mpill" data-medium="Editorial">Editorial</button>
            <button class="ce-mpill" data-medium="Documentary">Documentary</button>
            <button class="ce-mpill" data-medium="Other">Other</button>
          </div>
        </div>
        <div class="ce-step" id="ce-step-2" style="display:none">
          <h2 class="ce-modal-headline">Your portfolio.</h2>
          <div class="ce-field-wrap"><input id="ce-artist-url" type="url" placeholder=" " /><label for="ce-artist-url">Portfolio URL</label></div>
          <div class="ce-field-wrap"><input id="ce-artist-ig" type="text" placeholder=" " /><label for="ce-artist-ig">Instagram handle</label></div>
          <div class="ce-field-wrap"><textarea id="ce-artist-published" rows="2" placeholder=" "></textarea><label for="ce-artist-published">Where has your work been published?</label></div>
        </div>
        <div class="ce-step" id="ce-step-3" style="display:none">
          <h2 class="ce-modal-headline">Final details.</h2>
          <div class="ce-field-wrap"><input id="ce-artist-email" type="email" placeholder=" " /><label for="ce-artist-email">Your email</label></div>
          <div class="ce-field-wrap"><textarea id="ce-artist-note" rows="3" placeholder=" "></textarea><label for="ce-artist-note">Anything else?</label></div>
        </div>
        <div id="ce-artist-success" style="display:none;text-align:center;padding:2rem 0">
          <svg viewBox="0 0 52 52" style="width:60px;height:60px;display:block;margin:0 auto 1.5rem">
            <circle cx="26" cy="26" r="25" fill="none" stroke="rgba(180,160,255,0.5)" stroke-width="2"/>
            <path fill="none" stroke="rgba(180,160,255,0.9)" stroke-width="2.5"
              stroke-dasharray="48" stroke-dashoffset="48"
              style="animation:ceCheck 600ms cubic-bezier(0.16,1,0.3,1) 200ms forwards"
              d="M14 27l8 8 16-16"/>
          </svg>
          <h2 class="ce-modal-headline">Thank you.</h2>
          <p class="ce-modal-note">We'll be in touch.</p>
        </div>
        <div class="ce-artist-nav">
          <button id="ce-back-btn" class="ce-modal-btn ce-modal-btn--ghost" style="display:none">← Back</button>
          <button id="ce-next-btn" class="ce-modal-btn">Continue →</button>
        </div>
      </div>

    </div>
  </div>`;

  const css = `
  @keyframes ceCheck { to { stroke-dashoffset: 0; } }
  @keyframes ceShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
  @keyframes ceStepIn { from{opacity:0;transform:translateX(16px)} to{opacity:1;transform:translateX(0)} }

  #ce-modal-overlay {
    position:fixed;inset:0;z-index:99999;
    background:rgba(0,0,0,0.88);
    backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);
    display:flex;align-items:center;justify-content:center;
    opacity:0;pointer-events:none;
    transition:opacity 300ms cubic-bezier(0.16,1,0.3,1);
    padding:1rem;
  }
  #ce-modal-overlay.ce-open{opacity:1;pointer-events:all;}
  #ce-modal-panel {
    background:#0e0e0e;
    border:1px solid rgba(255,255,255,0.08);
    border-radius:2px;padding:3rem;
    width:100%;max-width:560px;max-height:90vh;overflow-y:auto;
    position:relative;
    transform:scale(0.95);opacity:0;
    transition:transform 380ms cubic-bezier(0.16,1,0.3,1),opacity 380ms cubic-bezier(0.16,1,0.3,1);
    color:#fff;
  }
  #ce-modal-overlay.ce-open #ce-modal-panel{transform:scale(1);opacity:1;}
  #ce-modal-close {
    position:absolute;top:1.5rem;right:1.5rem;
    background:none;border:none;color:rgba(255,255,255,0.35);
    font-size:1.1rem;cursor:pointer;line-height:1;padding:0.25rem;
    transition:color 200ms ease;
  }
  #ce-modal-close:hover{color:#fff;}
  .ce-modal-eyebrow{font-size:0.55rem;letter-spacing:0.22em;text-transform:uppercase;color:rgba(180,160,255,0.7);margin:0 0 0.6rem;}
  .ce-modal-headline{font-size:1.35rem;font-weight:200;letter-spacing:-0.02em;margin:0 0 1.6rem;color:#fff;}
  .ce-topic-pills{display:flex;flex-wrap:wrap;gap:0.5rem;margin-bottom:1.5rem;}
  .ce-pill{
    font-size:0.58rem;letter-spacing:0.18em;text-transform:uppercase;
    border:1px solid rgba(255,255,255,0.15);background:transparent;
    color:rgba(255,255,255,0.6);padding:0.4rem 1rem;border-radius:100px;
    cursor:pointer;transition:all 200ms cubic-bezier(0.16,1,0.3,1);
  }
  .ce-pill:hover{border-color:rgba(255,255,255,0.3);color:rgba(255,255,255,0.9);}
  .ce-pill.ce-pill--active{
    border-color:rgba(180,160,255,0.8);
    background:rgba(180,160,255,0.08);
    color:rgba(180,160,255,1);
    box-shadow:0 0 12px rgba(180,160,255,0.2);
  }
  #ce-search-wrap{
    max-height:0;overflow:hidden;
    transition:max-height 350ms cubic-bezier(0.16,1,0.3,1);
    margin-bottom:0;
  }
  #ce-search-wrap.ce-visible{max-height:420px;margin-bottom:1.2rem;}
  #ce-search-input{
    width:100%;background:transparent;border:none;
    border-bottom:1px solid rgba(255,255,255,0.2);
    color:#fff;font-size:0.9rem;font-weight:300;
    padding:0.6rem 0;outline:none;
    transition:border-color 200ms ease;font-family:inherit;
  }
  #ce-search-input:focus{border-bottom-color:rgba(180,160,255,0.6);}
  #ce-search-shimmer{
    height:1px;
    background:linear-gradient(90deg,transparent,rgba(180,160,255,0.7),transparent);
    background-size:200% 100%;display:none;
    animation:ceShimmer 1s infinite;
  }
  #ce-search-shimmer.ce-loading{display:block;}
  #ce-search-results{
    background:#161616;
    border:1px solid rgba(255,255,255,0.08);
    border-top:none;display:none;
    max-height:240px;overflow-y:auto;
  }
  #ce-search-results.ce-visible{display:block;}
  .ce-result-row{
    display:flex;align-items:center;gap:1rem;
    padding:0.75rem;cursor:pointer;
    transition:background 150ms ease;
    border-bottom:1px solid rgba(255,255,255,0.04);
  }
  .ce-result-row:last-child{border-bottom:none;}
  .ce-result-row:hover{background:rgba(255,255,255,0.05);}
  .ce-result-img{width:44px;height:44px;object-fit:cover;border-radius:2px;flex-shrink:0;background:rgba(255,255,255,0.05);}
  .ce-result-title{font-size:0.85rem;font-weight:300;color:#fff;}
  .ce-result-price{font-size:0.72rem;color:rgba(255,255,255,0.38);margin-top:2px;}
  .ce-result-empty{padding:1rem;font-size:0.78rem;color:rgba(255,255,255,0.3);font-style:italic;}
  #ce-selected-product{margin-top:0.6rem;}
  .ce-product-chip{
    display:inline-flex;align-items:center;gap:0.5rem;
    border:1px solid rgba(180,160,255,0.4);background:rgba(180,160,255,0.06);
    border-radius:100px;padding:0.3rem 0.8rem 0.3rem 0.4rem;
    font-size:0.75rem;color:rgba(255,255,255,0.85);
  }
  .ce-chip-img{width:24px;height:24px;object-fit:cover;border-radius:50%;}
  .ce-chip-remove{background:none;border:none;color:rgba(255,255,255,0.35);cursor:pointer;font-size:0.8rem;padding:0;line-height:1;transition:color 150ms ease;}
  .ce-chip-remove:hover{color:#fff;}
  .ce-field-wrap{position:relative;margin-bottom:1.4rem;}
  .ce-field-wrap input,.ce-field-wrap textarea{
    width:100%;background:transparent;border:none;
    border-bottom:1px solid rgba(255,255,255,0.15);
    color:#fff;font-size:0.9rem;font-weight:300;
    padding:1.2rem 0 0.4rem;outline:none;resize:none;
    transition:border-color 200ms ease;font-family:inherit;box-sizing:border-box;
  }
  .ce-field-wrap input:focus,.ce-field-wrap textarea:focus{border-bottom-color:rgba(180,160,255,0.6);}
  .ce-field-wrap label{
    position:absolute;top:1.2rem;left:0;
    font-size:0.85rem;color:rgba(255,255,255,0.32);
    pointer-events:none;
    transition:all 200ms cubic-bezier(0.16,1,0.3,1);
  }
  .ce-field-wrap input:focus ~ label,
  .ce-field-wrap input:not(:placeholder-shown) ~ label,
  .ce-field-wrap textarea:focus ~ label,
  .ce-field-wrap textarea:not(:placeholder-shown) ~ label{
    top:0;font-size:0.62rem;color:rgba(180,160,255,0.7);letter-spacing:0.06em;
  }
  .ce-modal-btn{
    width:100%;padding:1rem;margin-top:0.5rem;
    background:transparent;border:1px solid rgba(255,255,255,0.2);
    color:rgba(255,255,255,0.85);font-size:0.72rem;
    letter-spacing:0.14em;text-transform:uppercase;
    cursor:pointer;border-radius:1px;
    transition:all 380ms cubic-bezier(0.16,1,0.3,1);font-family:inherit;
  }
  .ce-modal-btn:hover{
    border-color:rgba(180,160,255,0.9);color:#fff;
    background:rgba(180,160,255,0.06);
    box-shadow:0 0 0 1px rgba(180,160,255,0.3),0 0 20px rgba(180,160,255,0.15);
    letter-spacing:0.18em;
  }
  .ce-modal-btn:active{transform:scale(0.98);}
  .ce-modal-btn--ghost{width:auto;padding:0.7rem 1.4rem;}
  .ce-modal-note{text-align:center;font-size:0.7rem;font-style:italic;color:rgba(255,255,255,0.28);margin-top:0.8rem;}
  .ce-artist-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:0.4rem;}
  #ce-step-indicator{font-size:0.62rem;color:rgba(255,255,255,0.28);letter-spacing:0.1em;}
  .ce-progress-dots{display:flex;gap:0.5rem;margin-bottom:1.8rem;}
  .ce-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.12);transition:background 300ms ease;}
  .ce-dot--active{background:rgba(180,160,255,0.9);}
  .ce-dot--done{background:rgba(180,160,255,0.35);}
  .ce-medium-pills{display:flex;flex-wrap:wrap;gap:0.4rem;margin-top:1rem;}
  .ce-mpill{
    font-size:0.6rem;letter-spacing:0.14em;text-transform:uppercase;
    border:1px solid rgba(255,255,255,0.12);background:transparent;
    color:rgba(255,255,255,0.45);padding:0.35rem 0.8rem;border-radius:100px;
    cursor:pointer;transition:all 200ms cubic-bezier(0.16,1,0.3,1);
  }
  .ce-mpill.ce-mpill--active{border-color:rgba(180,160,255,0.7);background:rgba(180,160,255,0.08);color:rgba(180,160,255,0.9);}
  .ce-artist-nav{display:flex;justify-content:space-between;gap:1rem;margin-top:1.5rem;}
  .ce-step{animation:ceStepIn 300ms cubic-bezier(0.16,1,0.3,1);}
  @media(max-width:767px){
    #ce-modal-overlay{align-items:flex-end;padding:0;}
    #ce-modal-panel{border-radius:2px 2px 0 0;max-width:100%;padding:2rem 1.5rem;}
  }`;

  /* INJECT */
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  /* REFS */
  var overlay       = document.getElementById('ce-modal-overlay');
  var generalPanel  = document.getElementById('ce-modal-general');
  var artistPanel   = document.getElementById('ce-modal-artist');
  var closeBtn      = document.getElementById('ce-modal-close');
  var pills         = document.querySelectorAll('.ce-pill');
  var searchWrap    = document.getElementById('ce-search-wrap');
  var searchInput   = document.getElementById('ce-search-input');
  var searchShimmer = document.getElementById('ce-search-shimmer');
  var searchResults = document.getElementById('ce-search-results');
  var selectedProd  = document.getElementById('ce-selected-product');

  var activeTopic      = '';
  var selectedProduct  = null;
  var searchTimer      = null;
  var currentStep      = 1;
  var selectedMediums  = [];

  /* OPEN / CLOSE */
  function openModal(type) {
    overlay.classList.add('ce-open');
    document.body.style.overflow = 'hidden';
    if (type === 'artist') {
      generalPanel.style.display = 'none';
      artistPanel.style.display  = 'block';
      goToStep(1);
    } else {
      generalPanel.style.display = 'block';
      artistPanel.style.display  = 'none';
      if (type === 'trade') selectPill('Trade & Interiors');
    }
  }

  function closeModal() {
    overlay.classList.remove('ce-open');
    document.body.style.overflow = '';
    setTimeout(resetModal, 400);
  }

  function resetModal() {
    pills.forEach(function(p) { p.classList.remove('ce-pill--active'); });
    searchWrap.classList.remove('ce-visible');
    searchResults.classList.remove('ce-visible');
    searchResults.innerHTML = '';
    selectedProd.innerHTML  = '';
    selectedProduct = null;
    activeTopic = '';
    ['ce-name','ce-email-field','ce-message'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.value = '';
    });
  }

  /* TRIGGERS */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-contact-modal]');
    if (trigger) { e.preventDefault(); openModal(trigger.dataset.contactModal); return; }
    if (e.target === overlay) closeModal();
  });
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('ce-open')) closeModal();
  });

  /* TOPIC PILLS */
  function selectPill(topic) {
    activeTopic = topic;
    pills.forEach(function(p) {
      p.classList.toggle('ce-pill--active', p.dataset.topic === topic);
    });
    if (topic === 'A specific artwork') {
      searchWrap.classList.add('ce-visible');
      setTimeout(function() { searchInput.focus(); }, 360);
    } else {
      searchWrap.classList.remove('ce-visible');
      searchResults.classList.remove('ce-visible');
      selectedProd.innerHTML = '';
      selectedProduct = null;
    }
  }
  pills.forEach(function(p) {
    p.addEventListener('click', function() { selectPill(p.dataset.topic); });
  });

  /* PRODUCT SEARCH */
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimer);
    var q = searchInput.value.trim();
    if (!q) {
      searchResults.classList.remove('ce-visible');
      searchShimmer.classList.remove('ce-loading');
      return;
    }
    searchShimmer.classList.add('ce-loading');
    searchTimer = setTimeout(function() { fetchProducts(q); }, 300);
  });

  function fetchProducts(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&limit=5')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        searchShimmer.classList.remove('ce-loading');
        var products = [];
        try { products = data.resources.results.products || []; } catch(e) {}
        renderResults(products);
      })
      .catch(function() {
        searchShimmer.classList.remove('ce-loading');
        renderResults([]);
      });
  }

  function renderResults(products) {
    searchResults.innerHTML = '';
    if (!products || !products.length) {
      searchResults.innerHTML = '<div class="ce-result-empty">No artworks found — try another title</div>';
      searchResults.classList.add('ce-visible');
      return;
    }
    products.forEach(function(p) {
      var row = document.createElement('div');
      row.className = 'ce-result-row';
      var imgSrc = '';
      if (p.image && p.image.url) imgSrc = p.image.url;
      else if (p.featured_image && p.featured_image.url) imgSrc = p.featured_image.url;
      else if (typeof p.image === 'string') imgSrc = p.image;
      var priceDisplay = p.price ? String(p.price) : '';
      row.innerHTML =
        (imgSrc ? '<img class="ce-result-img" src="' + imgSrc + '" alt="" loading="lazy">' : '<div class="ce-result-img"></div>') +
        '<div><div class="ce-result-title">' + (p.title || '') + '</div>' +
        (priceDisplay ? '<div class="ce-result-price">' + priceDisplay + '</div>' : '') + '</div>';
      row.addEventListener('click', function() { selectProduct(p); });
      searchResults.appendChild(row);
    });
    searchResults.classList.add('ce-visible');
  }

  function selectProduct(p) {
    selectedProduct = p;
    searchResults.classList.remove('ce-visible');
    searchInput.value = '';
    var imgSrc = '';
    if (p.image && p.image.url) imgSrc = p.image.url;
    else if (p.featured_image && p.featured_image.url) imgSrc = p.featured_image.url;
    selectedProd.innerHTML =
      '<div class="ce-product-chip">' +
      (imgSrc ? '<img class="ce-chip-img" src="' + imgSrc + '" alt="">' : '') +
      '<span>' + p.title + '</span>' +
      '<button class="ce-chip-remove" aria-label="Remove">&#x2715;</button></div>';
    selectedProd.querySelector('.ce-chip-remove').addEventListener('click', function() {
      selectedProduct = null;
      selectedProd.innerHTML = '';
    });
  }

  /* SUBMIT */
  document.getElementById('ce-submit').addEventListener('click', function() {
    var name    = document.getElementById('ce-name').value.trim();
    var email   = document.getElementById('ce-email-field').value.trim();
    var message = document.getElementById('ce-message').value.trim();
    var subject = activeTopic ? 'Enquiry: ' + activeTopic : 'Enquiry from danceartworks.com';
    var body    = 'Name: ' + name + '\nEmail: ' + email + '\n\nMessage:\n' + message;
    if (selectedProduct) body += '\n\nArtwork of interest:\n' + selectedProduct.title + '\nhttps://danceartworks.com' + selectedProduct.url;
    window.location.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  });

  /* ARTIST STEPS */
  document.querySelectorAll('.ce-mpill').forEach(function(p) {
    p.addEventListener('click', function() {
      var m = p.dataset.medium;
      var idx = selectedMediums.indexOf(m);
      if (idx > -1) { selectedMediums.splice(idx, 1); p.classList.remove('ce-mpill--active'); }
      else { selectedMediums.push(m); p.classList.add('ce-mpill--active'); }
    });
  });

  function goToStep(step) {
    currentStep = step;
    [1,2,3].forEach(function(s) {
      var el = document.getElementById('ce-step-' + s);
      if (el) el.style.display = s === step ? 'block' : 'none';
    });
    document.getElementById('ce-artist-success').style.display = 'none';
    document.getElementById('ce-step-indicator').textContent = 'Step ' + step + ' of 3';
    document.getElementById('ce-back-btn').style.display = step > 1 ? 'inline-block' : 'none';
    document.getElementById('ce-next-btn').textContent = step === 3 ? 'Send Portfolio →' : 'Continue →';
    document.querySelectorAll('.ce-dot').forEach(function(d, i) {
      d.classList.toggle('ce-dot--active', i + 1 === step);
      d.classList.toggle('ce-dot--done', i + 1 < step);
    });
  }

  document.getElementById('ce-next-btn').addEventListener('click', function() {
    if (currentStep < 3) { goToStep(currentStep + 1); return; }
    var name    = document.getElementById('ce-artist-name').value.trim();
    var desc    = document.getElementById('ce-artist-desc').value.trim();
    var url     = document.getElementById('ce-artist-url').value.trim();
    var ig      = document.getElementById('ce-artist-ig').value.trim();
    var pub     = document.getElementById('ce-artist-published').value.trim();
    var email   = document.getElementById('ce-artist-email').value.trim();
    var note    = document.getElementById('ce-artist-note').value.trim();
    var mediums = selectedMediums.join(', ');
    var body    = 'Name: ' + name + '\nMedium: ' + mediums + '\nPractice: ' + desc + '\n\nPortfolio: ' + url + '\nInstagram: ' + ig + '\nPublished: ' + pub + '\n\nEmail: ' + email + '\nNote: ' + note;
    window.location.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent('Artist Submission — ' + name) + '&body=' + encodeURIComponent(body);
    document.getElementById('ce-next-btn').style.display = 'none';
    document.getElementById('ce-back-btn').style.display = 'none';
    [1,2,3].forEach(function(s) { var el = document.getElementById('ce-step-' + s); if (el) el.style.display = 'none'; });
    document.getElementById('ce-artist-success').style.display = 'block';
  });

  document.getElementById('ce-back-btn').addEventListener('click', function() {
    if (currentStep > 1) goToStep(currentStep - 1);
  });

})();
